import axios from 'axios';

import type { PostApiV1ContentsData } from '~/api/generated';

export type ContentSubmission = NonNullable<PostApiV1ContentsData['body']>;

export async function createContent(content: ContentSubmission): Promise<void> {
  await axios.post('/api/v1/contents', content);
}
